import {
  GET_PROCESSORS,
  GET_PROCESSORS_ERROR,
  ADD_PROCESSOR,
  ADD_PROCESSOR_ERROR,
  UPDATE_PROCESSOR,
  UPDATE_PROCESSOR_ERROR,
  DELETE_PROCESSOR,
  DELETE_PROCESSOR_ERROR,
  GET_ACTIVE_PROCESSORS,
  GET_ACTIVE_PROCESSORS_ERROR,
  RESET_STORE,
  MANUALLY_TRIGGER_MESSAGE
} from "../types";

import { AddProcessorProps } from "../../types/actions/processor";

import * as api from "../../api/axiosBase";

export const getProcessors = () => async (dispatch) => {
  try {
    const { data } = await api.getProcessors();
    dispatch({ type: GET_PROCESSORS, payload: data.data });
    dispatch({ type: GET_PROCESSORS_ERROR, payload: "" });
  } catch (error) {
    //dispatch({ type: LOGIN, payload: error.response.data.status });
    dispatch({
      type: GET_PROCESSORS_ERROR,
      payload: error.response.data.message
    });
  }
};

export const getActiveProcessors = () => async (dispatch) => {
  try {
    const { data } = await api.getActiveProcessors();
    dispatch({ type: GET_ACTIVE_PROCESSORS, payload: data.data });
    dispatch({ type: GET_ACTIVE_PROCESSORS_ERROR, payload: "" });
  } catch (error) {
    //     dispatch({ type: LOGIN, payload: error.response.data.status });
    dispatch({
      type: GET_ACTIVE_PROCESSORS_ERROR,
      payload: error.response.data.message
    });
  }
};

export const addProcessor =
  (formData: AddProcessorProps, history: any) => async (dispatch) => {
    try {
      const { data } = await api.addProcessor(formData);
      dispatch({ type: ADD_PROCESSOR, payload: data.status });
      dispatch({ type: ADD_PROCESSOR_ERROR, payload: "" });
      dispatch(getActiveProcessors());
      //history.push("/processors");
    } catch (error) {

      dispatch({
        type: ADD_PROCESSOR_ERROR,
        payload: error.response.data.message
      });
      dispatch({ type: ADD_PROCESSOR, payload: error.response.data.status });
    }
  };

export const updateProcessor =
  (formData: AddProcessorProps, id: string) => async (dispatch) => {
    try {
      const { data } = await api.updateProcessor(id, formData);
      dispatch({ type: UPDATE_PROCESSOR, payload: data.status });
      dispatch({ type: UPDATE_PROCESSOR_ERROR, payload: "" });
      dispatch(getActiveProcessors());
      //history.push("/processors");
    } catch (error) {

      dispatch({
        type: UPDATE_PROCESSOR_ERROR,
        payload: error.response.data.message
      });
      dispatch({ type: UPDATE_PROCESSOR, payload: error.response.data.status });
    }
  };

export const deleteProcessor = (id) => async (dispatch) => {
  try {
    const res = await api.deleteProcessor(id);
    dispatch(getProcessors());
    dispatch({
      type: DELETE_PROCESSOR,
      payload: id
    });
  } catch (e) {
    dispatch({
      type: DELETE_PROCESSOR_ERROR,
      payload: e
    });
  }
};

export const manuallyTrigerMessage = (message: string) => (dispatch) => {
  dispatch({ type: MANUALLY_TRIGGER_MESSAGE, payload: message });
};

export const resetStore = () => (dispatch) => {
  dispatch({ type: RESET_STORE, payload: [] });
};
